module.exports = __webpack_public_path__ + "img/a-banner1-1.d9cdd6f6.png";